<template>
  <step-template :subStep="subStep">
    <v-card-text>
      <v-row>
        <v-row v-if="bannerSrc">
          <v-col>
            <img
              :lazy-src="bannerSrc"
              contain
              :src="bannerSrc"
              style="margin: 0 auto;"
            />
          </v-col>
        </v-row>
        <v-row v-if="title" style="width: 100%;">
          <v-col>
            <h3 class="pb-5 px-4 text-center text-break" v-html="title"></h3>
          </v-col>
        </v-row>
        <v-row v-if="messageAbove" style="width: 100%;">
          <v-col>
            <h5 
              class="text-center text-break" 
              v-html="messageAbove"
              >
            </h5>
          </v-col>
        </v-row>
        <v-row class="px-2 px-sm-5 justify-center">
          <v-col
            :cols="computedCols"
            v-for="button in _buttons"
            class="d-flex justify-center"
            style="max-width:300px;max-height:300px;"
          >
            <v-card outlined tile color="transparent" style="position: relative;">
              <!-- Checkmark overlay for multi-select -->
              <div 
                v-if="allowMultiple && activeButton(button)" 
                class="checkmark-overlay"
              >
                <div class="checkmark-circle">
                  <span class="checkmark-icon">&#10003;</span>
                </div>
              </div>
              <img
                v-if="button.url && !useRandomizer"
                :class="{'button-img-active' : activeButton(button)}"
                class="button-img img-fluid"
                :style="getButtonStyle(button.style, _buttons.indexOf(button), button)"
                contain
                :src="button.url"
                @click="select(button, $event)"
                @mouseenter="hoveredButtonIndex = _buttons.indexOf(button)"
                @mouseleave="hoveredButtonIndex = null"
              />
              <img
                v-else-if="button.url && useRandomizer"
                :class="{'button-img-active' : activeButton(button)}"
                class="button-img img-fluid button-img-disabled"
                :style="getButtonStyle(button.style, _buttons.indexOf(button), button)"
                contain
                :src="button.url"
                :disabled=true
                @mouseenter="hoveredButtonIndex = _buttons.indexOf(button)"
                @mouseleave="hoveredButtonIndex = null"
              />
              <v-btn
                v-else-if="!button.url && !useRandomizer"
                color="warning"
                rounded
                large
                :class="{'button-btn-active' : activeButton(button)}"
                class="button-btn"
                :style="getButtonLabelStyle(button.style, _buttons.indexOf(button), button)"
                @click="select(button, $event)"
                @mouseenter="hoveredButtonIndex = _buttons.indexOf(button)"
                @mouseleave="hoveredButtonIndex = null"
              >
                {{ button.name }}
              </v-btn>
              <v-btn
                v-else
                color="warning"
                rounded
                large
                class="button-btn button-btn-disabled"
                :disabled=!activeButton(button)
                :style="getButtonLabelStyle(button.style, _buttons.indexOf(button), button)"
                @mouseenter="hoveredButtonIndex = _buttons.indexOf(button)"
                @mouseleave="hoveredButtonIndex = null"
              >
                {{ button.name }}
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-row>
      <!-- Single Select Display -->
      <v-row v-if="!useRandomizer && !allowMultiple">
        <v-col v-if="selectedButton" class="mt-10 d-flex text-center justify-center">
          <h2><small>You <span v-if="previouslyTag">previously</span> selected:</small><br><span style="font-size:1.1em;margin-bottom:20px;">{{ selectedButton.name }}</span></h2>
        </v-col>
      </v-row>
      <!-- Multi Select Display -->
      <v-row v-else-if="!useRandomizer && allowMultiple">
        <v-col v-if="selectedButtons.length > 0" class="mt-10 d-flex text-center justify-center">
          <h2><small>You <span v-if="previouslyTag">previously</span> selected:</small><br><span style="font-size:1.1em;margin-bottom:20px;">{{ selectedButtonNames }}</span></h2>
        </v-col>
      </v-row>
      <!-- Randomizer Display -->
      <v-row v-else-if="useRandomizer">
        <v-col class="mt-10 d-flex text-center justify-center">
          <h2>
            <small>The
            <span style="color:#ff3f3f;"><b>RANDOMIZER</b></span>
            has selected:</small><br><span style="font-size:1.1em;margin-bottom:20px;">{{ selectedButtonNames }}</span>
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="messageBox" style="width: 100%;">
          <v-col>
            <v-sheet
            class="pa-6 mx-8 mt-5 mb-0"
            elevation="3"
            rounded
            :color=messageBoxBgColor
          >
            <h5 
              class="text-center text-break ma-0" 
              v-html="messageBox"
              :style="`color:${messageBoxTxtColor}`"
              >
            </h5>
          </v-sheet>
          </v-col>
        </v-row>
        <v-row v-if="messageBelow" style="width: 100%;">
          <v-col>
            <h5 
              class="text-center text-break mx-8 mt-5 mb-0" 
              v-html="messageBelow"
              >
            </h5>
          </v-col>
        </v-row>
    </v-card-text>
  </step-template>
</template>

<script>
/**
 * To use:
 - in the database, go to table substeps
 - find the substep row that you want this component
 - update the row field component='step-buttons'
 - update the row field component_props as a JSON like:
{
  "variables": { "vmodel": "CUSTOM_VARIABLE_NAME" },
  "buttons": [
    { "value": "CUSTOM_VARIABLE_VALUE1", "name": "CVD", "url": "/img/Comorbidity_CVD.4f230a8d.jpg" },
    { "value": "CUSTOM_VARIABLE_VALUE2", "name": "CKD", "url": "/img/Comorbidity_CKD.bfaecdfc.jpg" },
    {
      "value": "CUSTOM_VARIABLE_VALUE3",
      "name": "PCOS",
      "url": "/img/Comorbidity_PCOS.e12a30a2.jpg",
      "style": "background-color: #17a8de; border-radius: 25px;",
      "hoverStyle": "transform: scale(1.05); box-shadow: 0 8px 20px rgba(0,0,0,0.3);",
      "hide": { "avatar.gender": ["Male", "Transfemale"] }
    },
    OR
    { "value": true, "name": "Yes", "forceNextSubStepTo": 17 },
    { "value": false, "name": "No" }
  ],
  "borderColor":"green",
  "buttonsStyle": "",
  "buttonsHoverStyle": "",
  "bannerSrc": "/img/sdoh.487f9d98.jpg",
  "title": "Please select a Social Determinant of Health to explore.",
  "useRandomizer": true / false, (AS BOOLEAN)
}

* MULTI SELECT MODE (allows selecting multiple buttons)
{
  "variables": { "vmodel": "selected_options" },
  "allowMultiple": true,
  "minSelections": 1,
  "maxSelections": 3,
  "buttons": [
    { "value": "option1", "name": "Option 1", "url": "/img/option1.jpg" },
    { "value": "option2", "name": "Option 2", "url": "/img/option2.jpg" },
    { "value": "option3", "name": "Option 3", "url": "/img/option3.jpg" }
  ]
}
// Data stored: { value: ["option1", "option2"], fullObject: [{...}, {...}] }
// Log format: "Buttons Selected: selected_options: option1;option2"
// Note: forceNextSubStepTo is ignored in multi-select mode

NOTE: Use useRandomizer requires setting the Avatar override data:
{
    "override": [
        {
            "subStep": {
                "id": STEPNUMBER,
                "props": {
                    "vModelValue": BUTTONVALUE
                }
            }
        }
    ]
}

(only 'variables' and 'buttons' are required)
 */

import { mapState, mapMutations, mapActions } from "vuex";
import StepTemplate from "/src/components/steps/StepTemplate.vue";
import { controllers } from "chart.js";

export default {
  name: "StepButtons",
  components: {
    StepTemplate,
  },
  props: {
    steps: {
      type: Array,
      required: true,
    },
    step: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    subStep: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    variables: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    buttons: {
      type: Array,
      required: false,
      default: null,
    },
    buttonsStyle: {
      type: String,
      required: false,
      default: "",
    },
    buttonsHoverStyle: {
      type: String,
      required: false,
      default: "",
    },
    borderColor: {
      type: String,
      required: false,
      default: "gray",
    },
    bannerSrc: {
      type: String,
      default: "",
      required: false,
    },
    title: {
      type: String,
      default: "",
      required: false,
    },
    messageAbove: {
      type: String,
      required: false,
      default: "",
    },
    messageBox: {
      type: String,
      required: false,
      default: "",
    },
    messageBoxBgColor: {
      type: String,
      required: false,
      default: "#f0faff",
    },
    messageBoxTxtColor: {
      type: String,
      required: false,
      default: "#304156",
    },
    messageBelow: {
      type: String,
      required: false,
      default: "",
    },
    supportRandomizer: {
      type: Boolean,
      default: false,
      required: false,
    },
    randomizeButtonOrder: {
      type: Boolean,
      default: false,
      required: false,
    },
    allowMultiple: {
      type: Boolean,
      default: false,
      required: false,
    },
    minSelections: {
      type: Number,
      default: 1,
      required: false,
    },
    maxSelections: {
      type: Number,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      _buttons: [],
      selectedButton: null,
      selectedButtons: [],
      previouslyTag: true,
      useRandomizer: false,
      avatarOverridedVariables: {
        vModelValue: null,
      },
      hoveredButtonIndex: null,
    };
  },
  computed: {
    ...mapState({
      avatar: (state) => state.avatar,
      caseData: (state) => state.caseData,
      state: (state) => state,
    }),
    computedCols() {
      if (this._buttons.length === 1) {
        // 1 Row
        return 12;
      } else if (this._buttons.length === 2 || this._buttons.length === 4 ) {
        // 2 Rows
        return 6;
      } else if (this._buttons.length === 3 || this._buttons.length === 5 || this._buttons.length === 6) {
        // 3 Rows
        return 4;
      } else if (this._buttons.length === 7 || this._buttons.length === 8) {
        // 4 Rows
        return 3;
      }
      // 4 Rows
      return 3;
    },
    avatarVariables() {
      if (this.avatar.variables) {
        return JSON.parse(this.avatar.variables);
      }
      return null;
    },
    selectionCount() {
      if (this.allowMultiple) {
        return this.selectedButtons.length;
      }
      return this.selectedButton ? 1 : 0;
    },
    meetsMinimum() {
      return this.selectionCount >= this.minSelections;
    },
    canSelectMore() {
      if (!this.allowMultiple) return true;
      if (this.maxSelections === null) return true;
      return this.selectionCount < this.maxSelections;
    },
    isValidSelection() {
      return this.meetsMinimum;
    },
    selectedButtonNames() {
      if (this.allowMultiple) {
        return this.selectedButtons.map(b => b.name).join(', ');
      }
      return this.selectedButton ? this.selectedButton.name : '';
    },
  },
  created() {
    this.init();
    
  },
  methods: {
    ...mapMutations(["setBackButtonEnabled","setContinueButtonEnabled", "setForceNextSubStepTo"]),
    ...mapActions(["setCaseDataValue", "trackingAction"]),
    init() {
      this.setContinueButtonEnabled(false);
      this.setBackButtonEnabled(true);
      this.initButtons();
      this.loadPreviousSelectedChoice();
      if (this.randomizeButtonOrder && !this.selectedButton && this.selectedButtons.length === 0) {
        this.randomizeButtons(this._buttons);
      }
      // Enable continue if valid selection exists
      if (this.allowMultiple) {
        this.setContinueButtonEnabled(this.isValidSelection);
      } else if (this.selectedButton) {
        this.setContinueButtonEnabled(true);
      }
    },
    /**
     * Buttons can be received in specific props or in the substep
     * Props get priority
     */
    initButtons() {
      if (this.buttons) {
        this._buttons = this.filterButtons(this.buttons);
      }
    },
    randomizeButtons(buttonsArray) {
      let currentIndex = buttonsArray.length, randomIndex;
      while (currentIndex > 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [buttonsArray[currentIndex], buttonsArray[randomIndex]] = [
        buttonsArray[randomIndex], buttonsArray[currentIndex]];
      }
      return buttonsArray;
    },
    loadPreviousSelectedChoice() {
      if (this.avatar.random === true && this.supportRandomizer) {
        this.useRandomizer = true;
        this.setAvatarOverridedVariables();
        const avatarValue = this.avatarOverridedVariables.vModelValue
          ? this.avatarOverridedVariables.vModelValue
          : this.variables[this.variables.vmodel];
        
        if (this.allowMultiple && Array.isArray(avatarValue)) {
          // Multi-select with randomizer - load array of values
          this.selectedButtons = this._buttons.filter((button) =>
            avatarValue.includes(button.value)
          );
          if (this.selectedButtons.length > 0) {
            const values = this.selectedButtons.map(b => b.value);
            this.setCaseDataValue({
              key: this.variables.vmodel,
              value: values,
              fullObject: this.selectedButtons,
              randomizer: this.useRandomizer,
            });
          }
        } else {
          // Single select with randomizer
          this.selectedButton = this._buttons.find((button) => {
            if (button.value == avatarValue) {
              this.setCaseDataValue({
                key: this.variables.vmodel,
                value: button.value,
                fullObject: button,
                randomizer: this.useRandomizer,
              });
              return true;
            }
          });
        }
      } else {
        const currentValue = this.caseData[this.variables.vmodel];
        if (!currentValue) return;
        
        if (this.allowMultiple && Array.isArray(currentValue)) {
          // Multi-select - load array of values
          this.selectedButtons = this._buttons.filter((button) =>
            currentValue.includes(button.value)
          );
        } else if (!this.allowMultiple) {
          // Single select
          this.selectedButton = this._buttons.find((button) => {
            if (button.value == currentValue) {
              return true;
            }
          });
        }
      }
      if (this.selectedButton && !this.allowMultiple) {
        this.checkForceNextSubStepTo();
      }
    },
    setAvatarOverridedVariables() {
      if (!this.avatarVariables || !this.avatarVariables.override) {
        return;
      }
      const override = this.avatarVariables.override;
      for (const i in override) {
        if (override[i].subStep && this.matchesSubStepId(override[i].subStep.id)) {
          if (override[i].subStep.props)
            this.addAvatarOverridedVariables(override[i].subStep.props);
        }
      }
    },
    matchesSubStepId(id) {
      // Support both single id and array of ids, with type coercion for string/number comparison
      const currentId = this.subStep.id;
      if (Array.isArray(id)) {
        return id.some(arrId => String(arrId) === String(currentId));
      }
      return String(id) === String(currentId);
    },
    addAvatarOverridedVariables(overrideProps) {
      for (const key in overrideProps) {
        this.avatarOverridedVariables[key] = overrideProps[key];
      }
    },
    filterButtons(buttons) {
      return buttons.filter((button) => {
        if (button.hide) {
          
          for (const filterVariables in button.hide) {
            const filterVariable = filterVariables.split(".");
            const currentValue = String(this.state[filterVariable[0]][
              filterVariable[1]
            ]);
            if (button.hide[filterVariables].indexOf(String(currentValue)) !== -1) {
              return false;
            }
          }
        }
        return true;
      });
    },
    select(button, $event) {
      this.previouslyTag = false;
      if (this.allowMultiple) {
        this.selectMultiple(button);
      } else {
        this.selectSingle(button);
      }
    },
    selectSingle(button) {
      this.setCaseDataValue({
        key: this.variables.vmodel,
        value: button.value,
        fullObject: button,
        randomizer: this.useRandomizer,
      });
      this.selectedButton = button;
      this.checkForceNextSubStepTo();
      this.setContinueButtonEnabled(true);
      this.trackingAction(`Buttons Selected: ${this.variables.vmodel}: ${button.value}`);
      if (button.backButton === "disable") {
        this.setBackButtonEnabled(false);
      } else {
        this.setBackButtonEnabled(true);
      }
    },
    selectMultiple(button) {
      const index = this.selectedButtons.findIndex(b => b.value === button.value);
      if (index > -1) {
        // Deselect: remove from array
        this.selectedButtons.splice(index, 1);
      } else {
        // Select: add to array if under max
        if (this.canSelectMore) {
          this.selectedButtons.push(button);
        }
      }
      // Store array of values and array of full objects
      const values = this.selectedButtons.map(b => b.value);
      this.setCaseDataValue({
        key: this.variables.vmodel,
        value: [...values],
        fullObject: [...this.selectedButtons],
        randomizer: this.useRandomizer,
      });
      // Update continue button based on valid selection
      this.setContinueButtonEnabled(this.isValidSelection);
      // Log with semicolon-delimited values
      const logValues = values.join(";");
      this.trackingAction(`Buttons Selected: ${this.variables.vmodel}: ${logValues}`);
    },
    activeButton(button) {
      if (this.allowMultiple) {
        return this.selectedButtons.some(b => b.value === button.value);
      }
      if (this.selectedButton) {
        if (this.selectedButton.backButton === "disable") {
          this.setBackButtonEnabled(false);
        } else {
          this.setBackButtonEnabled(true);
        }
        return this.selectedButton.value === button.value;
      }
      return false;
    },
    isButtonSelected(buttonValue) {
      if (this.allowMultiple) {
        return this.selectedButtons.some(b => b.value === buttonValue);
      }
      return this.selectedButton && this.selectedButton.value === buttonValue;
    },
    checkForceNextSubStepTo() {
      // forceNextSubStepTo is ignored in multi-select mode
      if (this.allowMultiple) {
        this.setForceNextSubStepTo(null);
        return;
      }
      if (this.selectedButton && this.selectedButton.forceNextSubStepTo) {
        this.setForceNextSubStepTo(this.selectedButton.forceNextSubStepTo);
      } else {
        this.setForceNextSubStepTo(null);
      }
    },
    getButtonLabelStyle(style, index, button) {
      let s =
        "object-fit: contain !important; max-width: 100% !important; max-height: 100% !important;";
      if (style) {
        s += style;
      } else if (this.buttonsStyle) {
        s += this.buttonsStyle;
      }
      // Apply hover style if this button is hovered (button-level hoverStyle takes precedence)
      if (this.hoveredButtonIndex === index) {
        if (button && button.hoverStyle) {
          s += button.hoverStyle;
        } else if (this.buttonsHoverStyle) {
          s += this.buttonsHoverStyle;
        }
      }
      return s;
    },
    getButtonStyle(style, index, button) {
      let s =
        "object-fit: contain !important; max-width: 100% !important; max-height: 100% !important; width: auto !important; height: auto !important; max-width: inherit !important;";
      if (style) {
        s += style;
      } else if (this.buttonsStyle) {
        s += this.buttonsStyle;
      } else {
        s += `background-color:white;border:1px solid ${this.borderColor}; border-radius: 15px;`;
      }
      // Apply hover style if this button is hovered (button-level hoverStyle takes precedence)
      if (this.hoveredButtonIndex === index) {
        if (button && button.hoverStyle) {
          s += button.hoverStyle;
        } else if (this.buttonsHoverStyle) {
          s += this.buttonsHoverStyle;
        }
      }
      return s;
    }
  },
};
</script>
<style>
  .button-img, .button-btn {
    opacity: 1;
    box-shadow: none;
    transition: transform ease 0.3s, box-shadow ease 0.5s;
  }
  .button-img {
    cursor: pointer; 
  }
  .button-img:active {
    transform: scale(.99);
  }
  .button-img-disabled {
    opacity:.5;
    cursor: initial; 
  }
  .button-img-active, .button-btn-active {
    transform: scale(1.1) translateY(-2px);
    opacity:1;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2) !important;
  }
  /* Checkmark overlay for multi-select */
  .checkmark-overlay {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 10;
    pointer-events: none;
  }
  .checkmark-circle {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.5);
  }
  .checkmark-icon {
    color: white;
    font-size: 18px;
    font-weight: bold;
  }
</style>